import { AddCustomerDTO, CustomerPaginationDTO, EditCustomerDTO} from "../../dtos/batch";
import axios from "../../utils/axiosConfig";
axios.defaults.withCredentials = true;

const getCustomerHistory = async (pharmacy_id: any, dto?: CustomerPaginationDTO) => {
    let url = `/api/pharmacy_customer/get?pharmacy_id=${pharmacy_id}`;
    if (dto) {
        if (dto.page) url += `&page=${encodeURIComponent(dto.page)}`
        if (dto.limit) url += `&limit=${encodeURIComponent(dto.limit)}`
        if (dto.search) url += `&search=${encodeURIComponent(dto.search)}`
    }
    const { data } = await axios.get(url);
    return data;
};

const getAllInvoices = async (pharmacy_id: any, customer_id: any) => {
    let url = `/api/pharmacy_customer/get_customer_invoices?customer_id=${customer_id}&pharmacy_id=${pharmacy_id}`;
    const { data } = await axios.get(url);
    return data;
};



const editedCustomer = async (dto: EditCustomerDTO) => {
    const { data } = await axios.put( "/api/pharmacy_customer/update", dto);
    return data;
  };

  const addCustomerPayment = async (dto: AddCustomerDTO) => {
    const { data } = await axios.post( "/api/pharmacy_customer/add_payment", dto);
    return data;
  };
  
const customerHistoryService = {
    addCustomerPayment,
    getCustomerHistory,
    editedCustomer,
    getAllInvoices
};
export default customerHistoryService;